import { type WithRef } from '@principle-theorem/shared';
import { type IUser } from './user';

export interface IUserHasPermissionPair {
  user: WithRef<IUser>;
  hasPermission: boolean;
}
